import { create } from 'zustand';

interface State {
  delayUntil: Date;
}

interface Actions {
  readonly setDelayUntil: (future: Date) => void;
}

interface Store extends State, Actions {}

// to queue up toasts from various components and prevent showing multiple toasts at once
const useToastsStore = create<Store>((set, get) => {
  return {
    delayUntil: new Date(),

    setDelayUntil: (future) => {
      set({ delayUntil: future });
    },
  };
});

export default useToastsStore;
